import { render, staticRenderFns } from "./1020.vue?vue&type=template&id=226c31da&scoped=true&"
import script from "./1020.vue?vue&type=script&lang=js&"
export * from "./1020.vue?vue&type=script&lang=js&"
import style0 from "./1020.vue?vue&type=style&index=0&id=226c31da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c31da",
  null
  
)

export default component.exports